import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=241c56db&scoped=true&"
import script from "./userData.vue?vue&type=script&lang=js&"
export * from "./userData.vue?vue&type=script&lang=js&"
import style0 from "./userData.vue?vue&type=style&index=0&id=241c56db&prod&lang=less&"
import style1 from "./userData.vue?vue&type=style&index=1&id=241c56db&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c56db",
  null
  
)

export default component.exports